export class MessageBarButtonInfo {
	constructor(public Title: string, public action: (...args: any[]) => any) { }
}